module.exports = __webpack_public_path__ + "ff00490b46a09e9c115ec1a8407aa555.svg";